<template>
    <div class="card-body p-0" style="background-color: rgb(255, 255, 255)">
        <div class="list-group arbol-max-height">
            <div v-if="grupos && grupos.length == 0" class="list-group-item">
                <p class="text-center p-3 mb-0 alert alert-warning">
                    No se encontraron grupos para esta institución
                </p>
            </div>

            <div class="list-group-item list-group-item-action menu-item-1" v-for="grupo in grupos" :key="grupo.id" :class="{ active: selectedGrupoId == grupo.id }" @click="selectGrupo(grupo)">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <i class="fas fa-chevron-right mr-1" style="color: rgb(199, 199, 199);"></i>
                        <span v-text="grupo.nombre"></span>
                        <p v-if="grupo.grado_grupo" class="m-0 pl-3" style="color: rgb(179, 179, 179);">
                            {{ grupo.grado_grupo.nombre }}
                        </p>
                    </div>
                    <div style="font-size: 1.2em">
                        <i v-if="grupo.flexible" class="fas fa-cube mr-1 text-info" title="Grupo flexible"></i>
                        <i v-if="!grupo.flexible" class="fas fa-cube mr-1" style="color: rgb(219, 219, 219);" title="Grupo flexible"></i>
                        <i v-if="grupo.grado_grupo && grupo.grado_grupo.id" class="fab fa-gofore mr-1 text-warning" title="Asociado a un grado"></i>
                        <i v-if="!grupo.grado_grupo || !grupo.grado_grupo.id" class="fab fa-gofore mr-1" style="color: rgb(219, 219, 219);" title="Asociado a un grado"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GruposList',
    inject: ['grupos$', 'selectedGrupoChange$'],
    data() {
        return {
            selectedGrupoId: ''
        }
    },
    methods: {
        selectGrupo(grupo) {
            this.selectedGrupoId = grupo.id;
            this.selectedGrupoChange$.next(grupo);
        }
    },
    subscriptions () {
        return {
            grupos: this.grupos$
        }
    }
}
</script>

<style>

</style>
